import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';

export interface BlockingRosterSummary {
  id: string;
  name: string;
  status: string;
}

@Component({
  selector: 'app-archive-assignment-blocked-modal',
  templateUrl: './archive-assignment-blocked-modal.component.html',
  styleUrls: ['./archive-assignment-blocked-modal.component.scss'],
})
export class ArchiveAssignmentBlockedModalComponent implements OnInit {
  title = 'Cannot archive assignment';
  message = '';
  rosters: BlockingRosterSummary[] = [];

  constructor(private modalCtrl: ModalController, private router: Router) {}

  ngOnInit() {}

  close() {
    this.modalCtrl.dismiss();
  }

  viewRoster(row: BlockingRosterSummary) {
    this.router.navigateByUrl(`/admin-fullscreen/new-roster/${row.id}`);
    this.modalCtrl.dismiss();
  }
}
